import { resource } from 'api'
import composerActions from '../composerAct'
import { DISPLAY_SHARED_RESOURCES, UPDATE_SHARED_RESOURCES, SELECT_SHARED_RESOURCES_TO_DOWNLOAD } from '../../../types/conversations/plugins'
import onDownloadMultipleFilesToZip from 'utils/downloadMultipleFilesToZip'

/**
 * Display sharedResources
 * @param {String} userId
 * @param {Boolean} isOpen
 * @param {Boolean} [isLoading=false]
 */
const displaySharedResources = (userId, isOpen, isLoading = false) => {
  return {
    type: DISPLAY_SHARED_RESOURCES,
    isOpen,
    userId,
    isLoading,
  }
}

/**
 * Update sharedResources
 * @param {String} userId
 * @param {Array} [sharedResources = []]
 */
const updateSharedResources = (userId, sharedResources = []) => {
  return {
    type: UPDATE_SHARED_RESOURCES,
    userId,
    sharedResources,
  }
}

/**
 * Update sharedResources to Download
 * @param {Array} [sharedResourcesToDownload = []]
 */
const updateSharedResourcesToDownload = (userId, sharedResourcesToDownload = []) => {
  return {
    type: SELECT_SHARED_RESOURCES_TO_DOWNLOAD,
    userId,
    sharedResourcesToDownload,
  }
}

/**
 * Close collapse for sharedResources plugin
 */
const close = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs
  dispatch(displaySharedResources(activeUser, false))
}

/**
 * Get sharedResources
 */
const get = ({ field = '', sort = '', search = '' }) => async (dispatch, getStore) => {
  try {
    const { activeUser } = getStore().tabs
    dispatch(displaySharedResources(activeUser, true, true))
    const { data, status } = await resource.pluginGetSharedFiles(activeUser, { sortByField: field, sortType: sort, search })
    if (status === 200) {
      dispatch(updateSharedResources(activeUser, data))
    }
  } catch (error) {
    console.error('error: ', error)
  }
}

const uploadFile = ({ file })  => async (dispatch, getStore) =>{
  try {
    const {
      _id, name, fileId, url, urlLong, mimeType, mimeSubtype,
      size, needRefresh, storageService, thumb, thumbId, extension
    } = file

    let fileToAppend = {
      name, fileId, url, urlLong, storageService,
      mimeType, mimeSubtype, size, needRefresh, thumb,
      extension, thumbId
    }

    if (needRefresh) {
      const { data } = await resource.refreshFileUrls(_id)
      fileToAppend.url = data.url
      fileToAppend.urlLong = data.urlLong
      fileToAppend.thumb = data.thumb
    }
    const { activeUser } = getStore().tabs
    dispatch(composerActions.updateFiles(activeUser, [fileToAppend]))
  } catch (error) {
    console.error('error: ', error)
  }
}

const updateFileName = ({ fileId, newFileName }) => async (dispatch, getStore) => {
  try {
    const { status } = await resource.updateFileName(fileId, { name: newFileName })
    if (status === 200) {
      dispatch(get({ field: '', sort: '', search: '' }))
      const { activeUser } = getStore().tabs
      const { conversations } = getStore()
      const { plugins: { sharedResources: { sharedResources } } } = conversations[activeUser]
      const newSharedResources = sharedResources.map(item => {
        if (item._id === fileId) {
          item.name = newFileName
        }
        return item
      })
      dispatch(updateSharedResources(activeUser, newSharedResources))
    }
  } catch (error) {
    console.error('error: ', error)
  }
}

const handleCheckSharedResourcesToDownload = (item) => (dispatch, getStore) => {
  const { activeUser } = getStore().tabs
  const { conversations } = getStore()
  const { plugins: { sharedResources: { sharedResourcesToDownload } } } = conversations[activeUser]
  const newSharedResourcesToDownload = [...sharedResourcesToDownload]
  const index = newSharedResourcesToDownload.indexOf(item)
  if (index > -1) {
    newSharedResourcesToDownload.splice(index, 1)
  } else {
    newSharedResourcesToDownload.push(item)
  }
  dispatch(updateSharedResourcesToDownload(activeUser, newSharedResourcesToDownload))
}

const handleDownloadMultipleSharedResources = () => (dispatch, getStore) => {
  const { activeUser } = getStore().tabs
  const { conversations } = getStore()
  const { plugins: { sharedResources: { sharedResourcesToDownload } } } = conversations[activeUser]
  sharedResourcesToDownload.forEach(url => {
    fetch(url).then(response => response.blob()).then(blob => {
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.setAttribute('download', '')
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(blobUrl)
      document.body.removeChild(link)
    }).catch(error => console.error('Error al descargar archivo:', error))
  })
}

const handleDownloadMultipleSharedResourcesAsZip =  () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs
  const { conversations } = getStore()
  const { plugins: { sharedResources: { sharedResourcesToDownload } } } = conversations[activeUser]
  onDownloadMultipleFilesToZip({ urls: sharedResourcesToDownload, downLoadFileName: 'shared_resources.zip' })
}

export default {
  uploadFile,
  get,
  updateFileName,
  close,
  handleCheckSharedResourcesToDownload,
  handleDownloadMultipleSharedResources,
  handleDownloadMultipleSharedResourcesAsZip,
}